<section class="seller-container">
  <section class="ids-pt-8">
    <h2 class="ids-text-title-01">salvar formulário</h2>
    <p class="ids-mv-4">Lembre de conferir seus dados com atenção antes de enviar</p>

    <ids-list>
      <li>
      <ids-accordion class="custom-accordion" header="dados empresa">
        <ng-container>
          <ul>
            <li class="ids-row ids-pv-4">
              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">razão social</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.corporateName }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">CNPJ</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.documentNumber | idsMask : maskCpfCnpj }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">tipo de sociedade</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.companyType }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">
                  data da última alteração social ou estatuária
                </h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.lastChangeDate | idsMask : 'date' }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">e-mail</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.contact.email }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nº de celular</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.contact.phone | idsMask : phone }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">CEP</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.address.zipCode | idsMask : cep }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">estado</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.address.state }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">cidade</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.address.city }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">endereço</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.address.street }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">número</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.address.number }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">bairro</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ dataCompany.address.district }}
                </p>
              </section>
            </li>
          </ul>
        </ng-container>
      </ids-accordion>
      </li>
      <li>
      <ids-accordion class="custom-accordion" header="dados representantes">
        <ul>
          <li class="ids-row ids-pv-4">
            <ng-container *ngFor="let representative of dataCompany.representatives;let i = index">
              <section class="ids-col-12">
                <h2 class="ids-text-section-02">representante {{ i + 1 }}</h2>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">nome</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ representative.name }}
                </p>
              </section>

              <section class="ids-col-6">
                <h3 class="ids-text-label-small ids-pv-2">CPF</h3>
                <p class="ids-text-section-01 ids-pb-4">
                  {{ representative.documentNumber | idsMask : maskCpfCnpj }}
                </p>
              </section>
            </ng-container>

            <ng-container *ngIf="dataCompany.attorneys">
              <ng-container *ngFor="let attorney of dataCompany.attorneys;let i = index">
                <section class="ids-col-12">
                  <h2 class="ids-text-section-02">procurador {{ i + 1 }}</h2>
                </section>
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">nome</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ attorney.name }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">CPF / CNPJ</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ attorney.documentNumber | idsMask : maskCpfCnpj }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">telefone</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ attorney.phone | idsMask : phone }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">e-mail</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ attorney.email }}
                  </p>
                </section>
              </ng-container>
            </ng-container>
          </li>
        </ul>
      </ids-accordion>
      </li>
      <li>
      <ids-accordion class="custom-accordion" header="dados bancários e adicionais">
        <ul>
          <li class="ids-row">
            <ng-container *ngFor="let bankAccount of dataCompany.bankAccounts;let i = index">
              <section class="ids-row ids-col-12">
                <h2 class="ids-col-12 ids-text-section-02">conta {{ i + 1 }}</h2>
                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">titular da conta</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ bankAccount.name }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">CNPJ</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ bankAccount.documentNumber | idsMask : maskCpfCnpj }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">tipo de conta</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ bankAccount.accountType | accountTypeLabel }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">número do banco</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ bankAccount.bankNumber }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">agência</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ bankAccount.agencyNumber }}
                  </p>
                </section>

                <section class="ids-col-6">
                  <h3 class="ids-text-label-small ids-pv-2">conta corrente</h3>
                  <p class="ids-text-section-01 ids-pb-4">
                    {{ bankAccount.accountNumber }}
                  </p>
                </section>
              </section>
            </ng-container>
          </li>
        </ul>
      </ids-accordion>
      </li>
    </ids-list>

    <section class="ids-pt-8">
      <h3 class="ids-section-01-bold ids-mb-4">declaração</h3>

      <form [formGroup]="declarationForm" class="ids-card ids-p-4">
        <ids-form-selection>
          <input
            type="checkbox"
            name="hasDeclaration"
            formControlName="hasDeclaration"
            [invalid]="hasError"
            idsCheckbox
            aria-describedby="invalid-message"
            required
          />

          Declaro, sob as penas da Lei, que as informações fornecidas acima expressam a realidade e
          podem ser comprovadas por documentação hábil, caso assim solicitado, principalmente no que
          se refer ao meu estado civil. Declaro ainda que as informações contidas na minha Certidão
          de Casamento permanecem válidas e inalteradas (quando for o caso).
        </ids-form-selection>
      </form>
    </section>
  </section>
</section>
